import { Serializable } from '@core/models';

export class SectionEngineeringProfitability extends Serializable {
  constructor(sectionGuid, currentProfitability, expectedProfitability) {
    super();
    this.sectionGuid = sectionGuid || null;
    this.currentProfitability = currentProfitability || 0;
    this.expectedProfitability = expectedProfitability || 0;
  }

  static toInstance(props = {}) {
    return new SectionEngineeringProfitability(props.section_guid, props.current_profitability, props.expected_profitability);
  }

  get profitability() {
    let profitability = 0;
    if (this.currentProfitability !== 0) profitability = (this.expectedProfitability - this.currentProfitability) / this.currentProfitability;
    return profitability;
  }
}
